// TODO: replace heuristic thresholds with backend-calibrated buckets when the matching service exposes them.
export const CONFIDENCE_THRESHOLDS = {
  high: 0.9,
  medium: 0.6,
} as const;

export enum ConfidenceBucket {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export type ChipKind = "success" | "warn" | "error";

export interface ConfidenceChip {
  bucket: ConfidenceBucket;
  kind: ChipKind;
  labelKey: string;
}

const CHIP_FOR_BUCKET: Record<ConfidenceBucket, ConfidenceChip> = {
  [ConfidenceBucket.HIGH]: {
    bucket: ConfidenceBucket.HIGH,
    kind: "success",
    labelKey: "receipts-confidence-high",
  },
  [ConfidenceBucket.MEDIUM]: {
    bucket: ConfidenceBucket.MEDIUM,
    kind: "warn",
    labelKey: "receipts-confidence-medium",
  },
  [ConfidenceBucket.LOW]: {
    bucket: ConfidenceBucket.LOW,
    kind: "error",
    labelKey: "receipts-confidence-low",
  },
};

export const getConfidenceBucket = (score: number): ConfidenceBucket => {
  if (score >= CONFIDENCE_THRESHOLDS.high) return ConfidenceBucket.HIGH;
  if (score >= CONFIDENCE_THRESHOLDS.medium) return ConfidenceBucket.MEDIUM;
  return ConfidenceBucket.LOW;
};

export const getConfidenceChip = (score: number): ConfidenceChip =>
  CHIP_FOR_BUCKET[getConfidenceBucket(score)];
